import React, { useState, useEffect, useRef } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { BloquearSocio, Btn, BtnAcao, Excluir } from '../../../../components/Acoes'
import ModalBloqueioSocio from './ModalBloqueioSocio'
import { mostrarToast } from '../../../../components/Toasts'
import { useHistory } from 'react-router-dom'
import { mensagens } from '../../../../util/Utilitarios'

import { consultar, excluir, get, putComAcao, salvar } from '../../../../util/AcessoApi'
import Yup from '../../../../util/Validacoes';
import { ModalCadastro } from '../../../../components/Modais';
import { Form, Formik } from 'formik';
import { LoadRelatorio } from '../../../../components/Loading';
import { InputPadrao, InputSwitch } from '../../../../components/Inputs';
import { InputSocio, InputSocioAtivos } from '../../../../components/InputsAutoCompleteV2';
import { BotaoPadrao } from '../../../../components/Botoes';
import { ACOES } from '../../../../util/Enums';
import { getUsuario } from '../../../../util/Configuracoes';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import { Visualizar, Alterar, EnviarNotificacao } from '../../../../components/Acoes';

const ConsultaCirurgiao = (props) => {
    const [data, setData] = useState([])
    const [filtros, setFiltros] = useState([])
    const [modalBloqueioSocio, setModalBloqueioSocio] = useState(false)
    const [cirurgiaoSetado, setCirurgiaoSetado] = useState(null)
    const history = useHistory()
    const target = useRef(null)
    const [itemCirurgiao, setItemCirurgiao] = useState(null)
    const [modalSocioPrioritario, setModalSocioPrioritario] = useState(false)


    const columns = React.useMemo(
        () => [
            {
                id: 'consulta-cirurgiao',
                columns: [
                    {
                        Header: 'Id',
                        accessor: 'id',
                        ordenamento: {
                            tipo: 'numero',
                            ativo: true,
                            modo: 'desc',
                        }
                    },
                    {
                        Header: 'Apelido',
                        accessor: 'apelido',
                        ordenamento: {
                            tipo: 'texto'
                        }
                    },
                    {
                        Header: 'Conselho Profissional',
                        accessor: 'conselho_profissional',
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            tipo: 'cro',
                            idColuna: 'cro_id'
                        }
                    },
                    {
                        Header: 'N° Conselho',
                        accessor: 'crm',
                        ordenamento: {
                            tipo: 'texto'
                        }

                    },
                    {
                        Header: 'Nome Cirurgião',
                        accessor: 'nome_cirurgiao',
                        ordenamento: {
                            tipo: 'texto'
                        }
                    },
                    {
                        Header: 'Telefone(s)',
                        accessor: 'telefones',
                        ordenamento: {
                            tipo: 'texto'
                        },

                    },
                    {
                        Header: 'Data Registro',
                        accessor: 'data_registro_formatada',
                        ordenamento: {
                            tipo: 'data'
                        },
                        // filtro:{
                        //     tipo: 'data',
                        //     idColuna: 'cirurgiao.data_registro'
                        // }
                    }
                ],

            },

        ],
        []
    )


    useEffect(() => {
        if (modalSocioPrioritario === false) {
            setItemCirurgiao({});
        }
    }, [modalSocioPrioritario])

    useEffect(() => {
        console.log('modalBloqueioSocio: ', modalBloqueioSocio);
        if (!modalBloqueioSocio) {
            setCirurgiaoSetado(null)
        }

    }, [modalBloqueioSocio])


    const exclusao = propsAcao => {

        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: props.modulo,
            acao_id: ACOES.EXCLUIR
        }
        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length) {
                excluir('/administracao/cirurgiao', propsAcao.id,
                    () => {
                        target.current.atualizar();
                        mostrarToast('sucesso', mensagens['sucesso'])
                    },
                    (e) => {
                        if (e.response && e.response.data && e.response.data.erros)
                            e.response.data.erros.forEach((item) => mostrarToast('erro', item))
                        else
                            mostrarToast('erro', mensagens.erro)
                    })
            }
            else
                mostrarToast('erro', mensagens['permissao'])

        }).catch((e) => mostrarToast('erro', mensagens['erro']))
    }

    const iniciarModalSocio = (row) => {
        setItemCirurgiao(row.id);
        setModalSocioPrioritario(true);
    }

    const OutrasAcoes = ({ propsAcao, ...props }) => {
        return (
            <Dropdown >
                <DropdownTrigger>
                    <Btn icone='icon-ellipsi' texto="Mais Ações" />
                </DropdownTrigger>
                <DropdownContent>
                    <div className="card-acoes-dropdown">
                        <div className="ajusta-dropdown-consulta-guia">
                            {[<Excluir to={'/administracao/estabelecimentoSaude/'} action={() => exclusao(propsAcao)} />,
                            <BtnAcao icone="icon-Add-UserStar" texto="Sócio Preferencial/Prioritário" action={() => iniciarModalSocio(propsAcao.row)} />,
                            <BloquearSocio icone={'icon-Lock-User'} texto={'Bloquear Sócio(s)'} action={() => { setCirurgiaoSetado({ value: propsAcao.id, label: (propsAcao.row.sigla + ' ' + propsAcao.row.crm_numero + ' - ' + propsAcao.row.nome_cirurgiao) }); setModalBloqueioSocio(true) }} />
                            ]}
                        </div>
                    </div>
                </DropdownContent>
            </Dropdown>
        )
    }


    const maisAcoesObj = [
        (propsAcao) => <Visualizar to={'/administracao/cirurgiao/visualizacao/' + propsAcao.id} />,
        (propsAcao) => <Alterar to={'/administracao/cirurgiao/alteracao/' + propsAcao.id} />,
        (propsAcao) => <OutrasAcoes propsAcao={propsAcao} />
    ]

    return (
        <>
            <div>

                <DataGridAlternativa removerTotalPaginas acoesObj={maisAcoesObj} target={target} data={data} columns={columns} setData={setData} acoes={true} caminhoBase='/administracao/cirurgiao' modulo={props.modulo} titulo={'Consulta Cirurgião'}
                    tituloLista={'Lista Cirurgião'} ImpressaoOff={true}
                    urlCadastro='/administracao/cirurgiao/cadastro' icone={'icon-File-ClipboardFileText'} caminhoConsultaFiltros='/administracao/cirurgiaoPaginacao' />
                <ModalBloqueioSocio cirurgiao={cirurgiaoSetado || []} setCirurgiao={setCirurgiaoSetado} abrirModal={modalBloqueioSocio} socioabrirModal={modalBloqueioSocio} setAbrirModal={setModalBloqueioSocio} />

                <SocioPrioritario
                    titulo={'Sócio Preferencial'} abrirModal={modalSocioPrioritario} setAbrirModal={setModalSocioPrioritario} item={itemCirurgiao} modulo={props.modulo} />

            </div>
        </>
    )
}

//principal?
//prioritário?
const SocioPrioritario = ({ target, ...props }) => {
    const [salvando, setSalvando] = useState(false)
    const [carregando, setCarregando] = useState(false)
    const refAtualizacao = useRef(null)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [showModalValidacao, setShowModalValidacao] = useState(false)
    const [mensagemModal, setMensagemModal] = useState('')
    const [cirurgiao, setCirurgiao] = useState(null);
    const [socios, setSocios] = useState(null);

    const [validacao] = useState(Yup.object({
    }))

    const Submit = (values) => {
        setSalvando(true);
        putComAcao(
            ACOES.PREFERENCIAL,
            props.modulo,
            values,
            '/administracao/cirurgiaoSocio',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                setSalvando(false)
                props.setAbrirModal(false)
            },
            (erro) => {
                // mostrarToast('erro', mensagens.erro);
                setSalvando(false)
            })
    }

    const obterCirurgiao = (idCirurgiao) => {
        setCarregando(true)
        Promise.resolve(get(`/administracao/cirurgiao/${idCirurgiao}`)).then(function (obj) {
            setCirurgiao(obj);
            setSocios(obj.socio);
            setValoresIniciais({ id: idCirurgiao, socio: obj.socio });
            setCarregando(false)
        }).catch((e) => {
            setCarregando(false)
        });
    }

    useEffect(() => {
        if (props.item)
            obterCirurgiao(props.item);
    }, [props.item]);

    const onChangePrioritatio = (propsFormik, idx) => {
        var sociosAntigos = propsFormik.values.socio;
        sociosAntigos[idx].prioritario = !sociosAntigos[idx].prioritario;
        propsFormik.setFieldValue('socio', sociosAntigos);
    }

    return (
        <>
            <ModalCadastro titulo={props.titulo} show={props.abrirModal} setShowModal={props.setAbrirModal}>
                <Formik
                    initialValues={valoresIniciais}
                    validationSchema={validacao}
                    enableReinitialize={true}
                    onSubmit={(values, propsFormik) => Submit}>
                    {propsFormik => (
                        <div ref={refAtualizacao}>
                            <Form>
                                <div className='modal-body-cadastro'>
                                    <div class="separator mt-10 mb-20"></div>
                                    <div className={'form-group col-12'}>
                                        <label className={'width-100 bold'}>Código</label>
                                        <label className={'width-100 mb-20'}>{cirurgiao ? cirurgiao.id || '--' : '--'}</label>
                                        <label className={'width-100 bold'}>Nome Cirurgião</label>
                                        <label className={'width-100 mb-20'}>{cirurgiao ? cirurgiao.nome_cirurgiao || '--' : '--'}</label>
                                        <label className={'width-100 bold'}>Conselho Profissional</label>
                                        <label className={'width-100 mb-20'}>{cirurgiao ? cirurgiao.descricao || '--' : '--'}</label>
                                        <label className={'width-100 bold'}>N° Conselho</label>
                                        <label className={'width-100 mb-20'}>{cirurgiao && cirurgiao.crm ? (cirurgiao.crm + ' - ' + cirurgiao.crm_estado) || '--' : '--'}</label>
                                        {carregando === true ? <LoadRelatorio refLoading={refAtualizacao} heigth={320} /> : <>

                                            {/* <InputPadrao label="Id" name="id" type="hidden" placeholder="Id" obrigatorio={true} /> */}
                                            <InputSocioAtivos label={<label className={'width-100 bold'}>Sócio Preferencial</label>} name="socio" placeholder="Sócio Preferencial" tamanho="p-0" propsFormik={propsFormik} multiplo
                                                autoFocus />
                                        </>}
                                    </div>
                                </div>
                                <div class="modal-header"><h5 class="modal-title"><span>Sócios Prioritários</span></h5></div>
                                <div class="separator mt-10 mb-10"></div>
                                {propsFormik.values.socio ? propsFormik.values.socio.map((x, idx) =>
                                    <div className="row-space-between ptb-15 plr-20 bb-1">
                                        <span className="titulo-acao">{x.label}</span>
                                        <InputSwitch
                                            tamanho={x.value}
                                            name={"socio-" + x.id}
                                            size="md"
                                            checked={x.prioritario}
                                            onChange={() => onChangePrioritatio(propsFormik, idx)}
                                        />
                                    </div>
                                ) : <></>}

                                <div className='direita container-botoes mb-3 group-salvar-novo'>
                                    <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => Submit(propsFormik.values)} idTooltip={"salvar"} />
                                </div>
                            </Form>
                        </div>
                    )}
                </Formik>
            </ModalCadastro>
        </>
    );
}

export default ConsultaCirurgiao